import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  TREQUEST_AI_ANALYTICS_FIRST_QUESTION,
  TREQUEST_AI_ANALYTICS_FOLLOW_UP_QUESTION,
  TREQUEST_AI_ANALYTICS_GENERATE_INSIGHTS,
  TREQUEST_AI_ANALYTICS_SUBMIT_FEEDBACK,
  TRESPONSE_AI_ANALYTICS_GENERATE_INSIGHTS,
  TRESPONSE_AI_ANALYTICS_QUESTION,
} from '@monorepo/types';
import { REnvProvider } from './report.env.provider';

@Injectable({
  providedIn: 'root',
})
export class AiAnalyticsProviderService {
  constructor(public http: HttpClient, private envProvider: REnvProvider) {}

  aiAnalyticsAskFirstQuestion(payload: TREQUEST_AI_ANALYTICS_FIRST_QUESTION) {
    const url = this.envProvider.getMachineMaintenanceEnvVar('AI_ANALYTICS_QUESTION');
    return this.http.post<TRESPONSE_AI_ANALYTICS_QUESTION>(url, payload);
  }

  aiAnalyticsAskFollowUpQuestion(payload: TREQUEST_AI_ANALYTICS_FOLLOW_UP_QUESTION) {
    const url = this.envProvider.getMachineMaintenanceEnvVar('AI_ANALYTICS_QUESTION');
    return this.http.post<TRESPONSE_AI_ANALYTICS_QUESTION>(url, payload);
  }

  aiAnalyticsGenerateInsights(payload: TREQUEST_AI_ANALYTICS_GENERATE_INSIGHTS) {
    const url = this.envProvider.getMachineMaintenanceEnvVar('AI_ANALYTICS_GENERATE_INSIGHTS');
    return this.http.post<TRESPONSE_AI_ANALYTICS_GENERATE_INSIGHTS>(url, payload);
  }

  aiAnalyticsSubmitFeedback(payload: TREQUEST_AI_ANALYTICS_SUBMIT_FEEDBACK) {
    const url = this.envProvider.getMachineMaintenanceEnvVar('CHATBOT_SUBMIT_FEEDBACK');
    return this.http.post<void>(url, payload);
  }
}
